var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1132_1125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.60013C6.66667 8.82216 6.97572 8.07605 7.52582 7.52595C8.07593 6.97584 8.82204 6.66679 9.6 6.66679H10.9333C11.7079 6.66635 12.4508 6.3596 13 5.81346L13.9333 4.88013C14.2059 4.60599 14.53 4.38845 14.887 4.24C15.244 4.09156 15.6267 4.01514 16.0133 4.01514C16.3999 4.01514 16.7827 4.09156 17.1397 4.24C17.4966 4.38845 17.8207 4.60599 18.0933 4.88013L19.0267 5.81346C19.576 6.36013 20.32 6.66679 21.0933 6.66679H22.4267C23.2046 6.66679 23.9507 6.97584 24.5009 7.52595C25.051 8.07605 25.36 8.82216 25.36 9.60013V10.9335C25.36 11.7068 25.6667 12.4508 26.2133 13.0001L27.1467 13.9335C27.4208 14.2061 27.6383 14.5302 27.7868 14.8871C27.9352 15.2441 28.0117 15.6269 28.0117 16.0135C28.0117 16.4001 27.9352 16.7828 27.7868 17.1398C27.6383 17.4968 27.4208 17.8209 27.1467 18.0935L26.2133 19.0268C25.6672 19.576 25.3604 20.3189 25.36 21.0935V22.4268C25.36 23.2048 25.051 23.9509 24.5009 24.501C23.9507 25.0511 23.2046 25.3601 22.4267 25.3601H21.0933C20.3188 25.3606 19.5759 25.6673 19.0267 26.2135L18.0933 27.1468C17.8207 27.4209 17.4966 27.6385 17.1397 27.7869C16.7827 27.9354 16.3999 28.0118 16.0133 28.0118C15.6267 28.0118 15.244 27.9354 14.887 27.7869C14.53 27.6385 14.2059 27.4209 13.9333 27.1468L13 26.2135C12.4508 25.6673 11.7079 25.3606 10.9333 25.3601H9.6C8.82204 25.3601 8.07593 25.0511 7.52582 24.501C6.97572 23.9509 6.66667 23.2048 6.66667 22.4268V21.0935C6.66623 20.3189 6.35947 19.576 5.81334 19.0268L4.88 18.0935C4.60587 17.8209 4.38833 17.4968 4.23988 17.1398C4.09143 16.7828 4.01501 16.4001 4.01501 16.0135C4.01501 15.6269 4.09143 15.2441 4.23988 14.8871C4.38833 14.5302 4.60587 14.2061 4.88 13.9335L5.81334 13.0001C6.35947 12.4509 6.66623 11.708 6.66667 10.9335V9.60013Z",
    fill: "#19BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.0002L14.6667 18.6668L20 13.3335",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1132_1125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBadge);
export default __webpack_public_path__ + "static/media/check-badge.2893ac2408930b0a73def4028a678f8f.svg";
export { ForwardRef as ReactComponent };